import { render, staticRenderFns } from "./CreateElectronicScript.vue?vue&type=template&id=ddd312ea"
import script from "./CreateElectronicScript.vue?vue&type=script&lang=js"
export * from "./CreateElectronicScript.vue?vue&type=script&lang=js"
import style0 from "./CreateElectronicScript.vue?vue&type=style&index=0&id=ddd312ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports